import React, {Component, PropTypes} from 'react';

// material-ui component
import LinearProgress from 'material-ui/LinearProgress';


class WaitingSequence extends Component {
  static propTypes = {
    endFunc: PropTypes.func.isRequired
  }

  constructor(props, context) {
    super(props, context);
  }

  state = {
    currentSlide: 0,
    progress: 0
  }

  render() {
    return (
      <div className='waiting-sequence'>
        <LinearProgress mode='indeterminate' color='#2eb0e3'/>
      </div>
    );
  }
}

export default WaitingSequence;



// WEBPACK FOOTER //
// ./shared/react/f_PreliminaryApplication/f_Application/r_ApplicationForm/r_CreateUserModal/c_WaitingSequence/index.js